import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import { SENTRY_DSN } from '@config';
import { App } from './App.tsx';
import { router } from './Router.tsx';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration(),
      // Drop errors whose stack consists only of code we did not bundle
      // (browser extensions, injected scripts like Google Translate).
      // 'npt-client' frames are marked via applicationKey in vite.config.ts.
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['npt-client'],
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
      }),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
